@if (!errorSavingChanges) {
	<div>
		<div class="header-container">
			@if (data.headerIcon && !loadingService.isLoading(this.data.loadingKeyOfApiFunction)) {
				<mat-icon [svgIcon]="data.headerIcon" class="pop-up-dialog-v2-icon"></mat-icon>
			}
			@if (loadingService.isLoading(this.data.loadingKeyOfApiFunction)) {
				<mat-spinner diameter="20" class="loading-spinner"></mat-spinner>
			}
			<h3>{{ data.headerTextBeforeLoading }}</h3>
		</div>
		@if (dialogDivider) {
			<mat-divider></mat-divider>
		}
		<mat-dialog-content>
			<div>
				{{ data.bodyTextBeforeLoading }}
			</div>
		</mat-dialog-content>
		<mat-dialog-actions>
			<button
				data-automation-id="loading-confirmation-negative-dialog-button"
				class="primary-small-button-wider"
				[class]="data.negativeButtonClass"
				(click)="onCloseClicked()"
				[disabled]="loadingService.isLoading(this.data.loadingKeyOfApiFunction)"
			>
				{{ data.negativeButtonDialogText }}
			</button>
			<button
				data-automation-id="loading-confirmation-positive-dialog-button"
				class="primary-small-button-wider"
				[class]="data.positiveButtonClass"
				(click)="onConfirmClicked()"
				[disabled]="loadingService.isLoading(this.data.loadingKeyOfApiFunction) || isContinueDisabled"
			>
				{{ data.positiveButtonDialogText }}
			</button>
		</mat-dialog-actions>
	</div>
}

@if (errorSavingChanges) {
	<div>
		<div class="header-container">
			@if (data.headerIcon) {
				<mat-icon [svgIcon]="data.headerIcon" class="pop-up-dialog-v2-icon"></mat-icon>
			}
			<h3 i18n="@@loadingConfirmationDialog-errorSavingChangesHeader">Error!</h3>
		</div>
		<mat-dialog-content>
			<div i18n="@@loadingConfirmationDialog-errorSavingChangesDesc">
				Could not save your changes at this time. Please try again.
			</div>
		</mat-dialog-content>
		<mat-dialog-actions>
			<button
				(click)="onCloseClicked()"
				class="primary-small-button primary-small-button-wider"
				i18n="@@loadingConfirmationDialog-errorSavingChangesConfirm"
				data-automation-id="save-changes-dialog-ok-button"
			>
				Ok
			</button>
		</mat-dialog-actions>
	</div>
}
